// removed by extract-text-webpack-plugin
module.exports = {"spinner":"index-module_spinner_mnKXe","rotator":"index-module_rotator_3SlpR","path":"index-module_path_25c-d","dash":"index-module_dash_LWNFS"};


//////////////////
// WEBPACK FOOTER
// ./client/components/icons/loadingSpinner/index.module.css
// module id = 267
// module chunks = 1 2 3